import React from "react";
import { useGroupByContent } from "hooks";
import { ReportsQueries } from "../../../store/types";

import "./SetTableColumns.styles.scss";
import { AutocompleteMeasures } from "./AutocompleteMeasures";

export type DataFormation = Partial<Pick<ReportsQueries, "measures" | "characteristics" | "calculatedFields">>;

interface SetTableColumnsProps {
  onChangeDataFormation?: (dataFormation: DataFormation) => void;
}

export const SetTableColumns: React.FC<SetTableColumnsProps> = ({ onChangeDataFormation }) => {
  const fields: Array<keyof ReportsQueries> = ["measures", "characteristics", "calculatedFields"];

  const { setFieldValue, values } = useGroupByContent({ fields, onChangeDataFormation });

  return (
    <div className="set-table-columns">
      <div className="group-by-content__title">Select Columns</div>
      <AutocompleteMeasures label="Columns" queries={values} setQueryValue={setFieldValue} />
    </div>
  );
};
